export enum Status {
  INATIVO = 'INATIVO',
  ATIVO = 'ATIVO',
  REMOVIDO = 'REMOVIDO',
}
